module.exports = __webpack_public_path__ + "media/images/fr_ca/goals-segment-31f0062172292eed51cff55dd9e5970e.jpg";